import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { UserMenuComponent } from 'src/app/layout/toolbar/user-menu/user-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { ContactUsDialogComponent } from './contact-us-dialog/contact-us-dialog.component';
import { IconsModule } from '../../icons/icons.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { ErrorModule } from '../../components/error/error.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationsModule } from 'src/app/components/notifications/notifications.module';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import {SearchFilterModule} from "../../components/search-filter/search-filter.module";


@NgModule({
  declarations: [
    ToolbarComponent,
    UserMenuComponent,
    ContactUsDialogComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule,
        MatMenuModule,
        IconsModule,
        MatDialogModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatDividerModule,
        ErrorModule,
        MatSlideToggleModule,
        FormsModule,
        NotificationsModule,
        MatIconModule,
        MatBadgeModule,
        SearchFilterModule
    ],
  exports: [
    ToolbarComponent
  ],
})
export class ToolbarModule { }
